import { css } from '@emotion/react';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useOnlineSchedulingDirectBookingAccess } from '@frontend/schedule-helpers';
import { Accordion } from '@frontend/design-system';
import { BookingSiteAppointmentLeadTimeSetting } from './BookingSiteAppointmentLeadTimeContent/AppointmentLeadTimeSetting';
import { BookingSiteLinks } from './BookingSiteLinks';
import { OnlineSchedulingModeSetting } from './online-scheduling-mode';
import { bookingSiteSetupBasePageTrackingIds } from './trackingIds';

const { bookingLinksAccordion, appointmentBookingAccordion, onlineSchedulingModeAccordion } =
  bookingSiteSetupBasePageTrackingIds;

export const BookingSiteSetup = () => {
  const { t } = useTranslation('schedule-settings');

  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();
  const { isOnlineSchedulingDirectBookingEnabled } = useOnlineSchedulingDirectBookingAccess();

  return (
    <>
      {isScheduleV3FlagEnabled ? (
        <Accordion css={{ maxWidth: 700 }}>
          <Accordion.Item value='booking-links' trackingId={bookingLinksAccordion}>
            <Accordion.Header>{t('Booking Links')}</Accordion.Header>
            <Accordion.Body css={{ padding: 0, borderRadius: 0 }}>
              <BookingSiteLinks />
            </Accordion.Body>
          </Accordion.Item>
          {isOnlineSchedulingDirectBookingEnabled && (
            <Accordion.Item value='online-scheduling-mode' trackingId={onlineSchedulingModeAccordion}>
              <Accordion.Header>{t('Online Scheduling Mode')}</Accordion.Header>
              <Accordion.Body css={accordionBodyStyle}>
                <OnlineSchedulingModeSetting />
              </Accordion.Body>
            </Accordion.Item>
          )}
          <Accordion.Item value='appointment-booking' trackingId={appointmentBookingAccordion}>
            <Accordion.Header>{t('Appointment Booking')}</Accordion.Header>
            <Accordion.Body css={accordionBodyStyle}>
              <BookingSiteAppointmentLeadTimeSetting />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      ) : (
        <BookingSiteLinks isAccordionContent={false} />
      )}
    </>
  );
};

const accordionBodyStyle = css`
  background: var(--fabric-color-neutral-00);
  padding: var(--fabric-space-padding-md) var(--fabric-space-padding-xl) var(--fabric-space-padding-lg)
    var(--fabric-space-padding-lg);
`;
